/* ROCKJAW "How It Began" story section: header offset, timeline rail state, reveals. No dependencies, no scroll listeners. */
(function () {
  var root = document.getElementById('hjb');
  if (!root) return;
  var qa = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };

  /* ---------- clear the theme's absolute header overlay; stick the rail under the theme header ---------- */
  try {
    var main = document.getElementById('MainContent') || root.parentNode;
    var measure = function () {
      /* the theme header is an absolute overlay at the top of <main> and turns fixed (top 0) on scroll,
         covering the sticky announcement bar; so the overlay offset is measured at scroll 0 and the
         sticky offset is the header's own height */
      var groups = document.querySelectorAll('.shopify-section-group-header-group');
      var tallest = 0, bottom = 0;
      Array.prototype.forEach.call(groups, function (g) {
        Array.prototype.forEach.call(g.children, function (c) {
          var r = c.getBoundingClientRect();
          if (r.height > tallest) tallest = r.height;
          if (r.height > 0) bottom = Math.max(bottom, r.bottom);
        });
      });
      if (tallest > 0 && tallest < 200) root.style.setProperty('--hjb-stick', Math.round(tallest) + 'px');
      if (window.scrollY === 0) {
        var top = Math.round(bottom - main.getBoundingClientRect().top);
        if (top >= 0 && top < 240) root.style.setProperty('--hjb-top', top + 'px');
      }
    };
    measure();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(measure, 150); });
    window.addEventListener('load', measure);
  } catch (e) {}

  if (!('IntersectionObserver' in window)) {
    qa('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  /* ---------- pause the values marquee while off-screen ---------- */
  try {
    qa('.values').forEach(function (el) {
      new IntersectionObserver(function (en) { el.classList.toggle('is-paused', !en[0].isIntersecting); }).observe(el);
    });
  } catch (e) {}

  /* ---------- timeline rail: the chapter crossing a line 40% down the viewport is "now" ---------- */
  try {
    var chapters = qa('.ch');
    var links = chapters.map(function (c) { return root.querySelector('[data-rail="' + c.id + '"]'); });
    var nowYr = root.querySelector('.rail-now-yr');
    var fill = root.querySelector('.rail-fill');
    var current = -2;
    var setActive = function (i) {
      if (i === current) return;
      current = i;
      links.forEach(function (a, j) {
        if (!a) return;
        a.classList.toggle('is-active', j === i);
        a.classList.toggle('is-past', j < i);
        if (j === i) a.setAttribute('aria-current', 'step'); else a.removeAttribute('aria-current');
      });
      if (nowYr && links[Math.max(i, 0)]) nowYr.textContent = links[Math.max(i, 0)].textContent;
      if (fill) fill.style.transform = 'scaleY(' + ((i + 1) / chapters.length).toFixed(3) + ')';
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) setActive(chapters.indexOf(en.target));
      });
    }, { rootMargin: '-40% 0px -59% 0px' });
    chapters.forEach(function (c) { io.observe(c); });
    /* back above the story: nothing is "now" yet (indexOf returns -1 for the opening) */
    var opening = root.querySelector('.opening');
    if (opening) io.observe(opening);
    setActive(-1);
  } catch (e) {}

  /* ---------- reveals: once, transform + opacity only ---------- */
  try {
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    qa('.reveal').forEach(function (el) { rio.observe(el); });
  } catch (e) {
    qa('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
